import React, { useCallback, createContext, useContext, useEffect, useRef } from 'react';
import usePublications from '../usePublications/usePublications';
import { BeaconEventData, BeaconEvents, DatatrackDataTypes, useHostDataTrack, useScreenShareToggle, useVideoContext } from '@alucio/video';
import { useState } from 'react';
import { GenericToast, ToastOrientations, useToast } from '@alucio/lux-ui';
export const AttendeeShareScreenContext = createContext(null);
export const AttendeeIsSharing = (participant) => {
    const publications = usePublications(participant);
    return publications.some(p => p.trackName.includes('screen'));
};
export const AttendeeShareScreenProvider = (props) => {
    const hostDataTrack = useHostDataTrack();
    const [askForShare, setAskForShare] = useState(false);
    const [_, __, startSharing, stopSharing] = useScreenShareToggle();
    const toast = useToast();
    const { room } = useVideoContext();
    const { localParticipant } = room;
    // To avoid the race condition between two users sharing at the same time
    // The last asked to share will have priority over the other ones
    const lastPresenter = useRef();
    const sendMessage = (remoteParticipant, share) => {
        var _a, _b, _c, _d;
        share && sendStopAllShareScreen();
        const msgObj = new BeaconEventData(BeaconEvents.shareScreen, {
            participantSid: remoteParticipant.sid,
            share,
            id: remoteParticipant.identity
        });
        const track = (_d = (_c = (_b = (_a = localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.dataTracks) === null || _a === void 0 ? void 0 : _a.values()) === null || _b === void 0 ? void 0 : _b.next()) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.track;
        track.send(JSON.stringify(msgObj));
    };
    const sendStopAllShareScreen = () => {
        var _a, _b, _c, _d;
        const msgObj = new BeaconEventData(BeaconEvents.stopAllShareScreen);
        const track = (_d = (_c = (_b = (_a = localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.dataTracks) === null || _a === void 0 ? void 0 : _a.values()) === null || _b === void 0 ? void 0 : _b.next()) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.track;
        track === null || track === void 0 ? void 0 : track.send(JSON.stringify(msgObj));
        lastPresenter.current = undefined;
    };
    const askToShare = (untypedMsg) => {
        const { participantSid, id, share } = untypedMsg.param;
        if (participantSid === (localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.sid)) {
            setAskForShare(share);
            // The host cancel the sharing
            !share && stopSharing();
        }
        lastPresenter.current = id;
    };
    const onHostMessage = useCallback((message) => {
        const untypedMsg = JSON.parse(message);
        if (untypedMsg.type === DatatrackDataTypes.BeaconEvent &&
            untypedMsg.event === BeaconEvents.shareScreen) {
            askToShare(untypedMsg);
        }
        else if (untypedMsg.type === DatatrackDataTypes.BeaconEvent &&
            untypedMsg.event === BeaconEvents.stopAllShareScreen) {
            stopSharing();
            lastPresenter.current = undefined;
        }
    }, [localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.sid]);
    const shareHandler = (share) => {
        share ? startSharing((share) => {
            const { identity } = localParticipant;
            if (identity === lastPresenter.current) {
                share();
            }
            else {
                toast.add(React.createElement(GenericToast, { title: 'Host has revoked the permission to share', status: "information" }), ToastOrientations.TOP_RIGHT_MEETINGS);
            }
        }) : stopSharing();
        // collapse modal for permissions
        setAskForShare(false);
    };
    useEffect(() => {
        if (hostDataTrack) {
            hostDataTrack.on('message', onHostMessage);
        }
        return () => {
            hostDataTrack === null || hostDataTrack === void 0 ? void 0 : hostDataTrack.off('message', onHostMessage);
        };
    }, [hostDataTrack, localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.sid]);
    return (React.createElement(AttendeeShareScreenContext.Provider, { value: { askForShare, sendMessage, sendStopAllShareScreen, shareHandler } }, props.children));
};
export default function useAttendeeShareScreen() {
    return useContext(AttendeeShareScreenContext);
}
//# sourceMappingURL=AttendeeShareScreen.js.map